module.exports = __webpack_public_path__ + "img/ico-tip.c0f2ed5a.svg";